import React, { memo, useEffect, useState } from 'react'
import effects from 'app/effects/effects'
import { debounce } from 'lodash'

import { Paper, TextField, makeStyles } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import themesConfig from 'app/fuse-configs/themesConfig'

const inputHover = {
  border: `1px solid ${themesConfig.default.colors['grey-100']}`,
  cursor: 'pointer !important',
}

const inputFocus = {
  boxShadow: `0px 0px 2px 1px ${themesConfig.default.colors.secondary}`,
  border: `1px solid ${themesConfig.default.colors.secondary}`,
  cursor: 'text !important',
}

const useStyles = makeStyles(() => ({
  customPaper: {
    width: '100%',
    minWidth: 200,
    overflow: 'auto',
    marginTop: 15,
    maxHeight: 300,
    fontSize: 14,
    color: themesConfig.default.colors.primary,
    lineHeight: '20px',
  },

  root: {
    '& .MuiOutlinedInput-root': {
      padding: 0,
      color: themesConfig.default.colors['dove-gray'],
      fontSize: 16,
      lineHeight: 'normal',
      '& fieldset': {
        border: `1px solid transparent`,
        width: '100%',
        fontSize: 16,
        backgroundColor: 'transparent',
        borderRadius: 1,
        padding: '8px 6px',

        '& legend': {
          display: 'none',
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        top: '0px',
      },
      '&:hover fieldset': {
        ...inputHover,
      },
      '&.Mui-focused fieldset': {
        ...inputFocus,
      },
    },
  },
}))

const AutocompleteJobTitle = ({
  currentValueInput,
  onChange,
  textFieldStyles,
  textFieldProps = {},
}) => {
  const [value, setValue] = useState(currentValueInput)
  const [localState, setLocalState] = useState({ suggestions: [] })

  const classes = useStyles()

  useEffect(() => {
    const fetchSuggestions = debounce((jobTitle) => {
      effects.apis
        .findJob({ jobTitle })
        .then((suggestions) => {
          setLocalState({ suggestions })
        })
        .catch((error) => {
          console.error('Error fetching job suggestions:', error)
        })
    }, 300)

    if (value && currentValueInput !== value) {
      fetchSuggestions(value)
    }

    return () => {
      fetchSuggestions.cancel()
    }
  }, [value, currentValueInput])

  const onChangeInput = (e) => {
    setValue(e.target.value)
  }

  const handleSelectOption = (_, newValue) => {
    setValue(newValue)
    onChange(newValue)
  }

  return (
    <div>
      <Autocomplete
        freeSolo
        disableClearable
        options={localState?.suggestions?.map((option) => option.name) || []}
        onChange={handleSelectOption}
        inputValue={value}
        PaperComponent={(props) => (
          <Paper {...props} elevation={2} className={classes.customPaper} />
        )}
        renderInput={(params) => (
          <TextField
            fullWidth
            value={value}
            onChange={onChangeInput}
            variant="outlined"
            className={textFieldStyles || classes.root}
            {...params}
            {...textFieldProps}
          />
        )}
      />
    </div>
  )
}

export default memo(AutocompleteJobTitle)
